import Rooms from '../pages/rooms';
import RoomDetail from '../pages/room-detail';
import Events from '../pages/events';
import EventDetail from '../pages/event-detail';
import UserList from '../pages/user-list';
import LandingPage from '../pages/landing_page';

const authRoutes = [
    // { path: "/rooms/:id", component: RoomDetail},
    // { path: "/rooms", component: Rooms },
    { path: "/user-list", component: UserList},
    { path: "/detail/:id", component: EventDetail},
    { path: "/", component: Events},
];

const publicRoutes = [
    { path: "/landing-page", component: LandingPage}
];

export { authRoutes, publicRoutes };